import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import CustomCursor from '../components/CustomCursor';
import { loadWordingJson } from '../utils/wordingSystem';
import Routes from '../routes';
import './index.scss';
import SNSPanel from '../components/SNSPanel';

// Component
import Header from '../components/Header';
import Footer from '../components/Footer';
import PreloadScreen from '../components/PreloadScreen';
import LoadingScreen from '../components/LoadingScreen';

import { lockWindow } from '../utils/methods';
import { Helmet } from 'react-helmet';

// Wording File
const wordingFile = '/wording/main.json?v=20250324';

const App = () => {
  const [overlayStatus, setOverlayStatus] = useState('hide');
  const [loadFinish, setLoadFinish] = useState(true);
  const [wording, setWording] = useState(null);

  useEffect(() => {
    loadWordingJson(wordingFile).then(result => setWording(result));
  }, []);

  useEffect(() => {
    if (overlayStatus === 'start') { lockWindow(true) };
    if (overlayStatus === 'hide') { lockWindow(false) };
  }, [overlayStatus])

  function startTransition() {
    setOverlayStatus('start');
  }

  function afterLoading() {
    setLoadFinish(true);
  }

  function endTransition() {
    window.scrollTo(0, 0);
    setOverlayStatus('end');
    setTimeout(() => { setOverlayStatus('hide') }, 600);
  }

  return (
    <BrowserRouter>
      <Route render={({ location, history, match }) => {
        return (
          <div id="app">
            <CanonicalTagHelper />
            <CustomCursor />
            {/* <PreloadScreen afterEnd={afterLoading} /> */}
            <LoadingScreen className={overlayStatus} />
            {
              loadFinish &&
              <div id="content-frame">
                {
                  wording &&
                  <Header wording={wording['header']} />
                }
                <TransitionGroup className={'router-wrapper'}>
                  <CSSTransition
                    timeout={800}
                    classNames={'overlay'}
                    key={location.pathname}
                    onEnter={startTransition}
                    onExited={endTransition}
                  >
                    <main className={'main'}>
                      {wording && <Routes loadFinish={overlayStatus === 'hide' ? true : false} wording={wording} location={location} />}
                    </main>
                  </CSSTransition>
                </TransitionGroup>
                {
                  wording &&
                  <Footer wording={wording['footer']} common={wording['common']} />}
              </div>
            }
          </div>
        )
      }} />
    </BrowserRouter>
  )
}

const CanonicalTagHelper = () => {
    const router = useLocation();

    useEffect(() => {
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) {
            canonical.href = `https://yoodesign.com.tw${router.pathname}`;
        }
    }, [router.pathname])

    return null;
}

export default App;
